require.register("modules/m02/m02-activity/page-21a-co/page-21a", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page21aco = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page21aco;

  
});

